<template>
  <div>
    <b-row>
      <b-col lg="4">
        <b-form-group label="Brand &amp; Branch">
          <b-dropdown
            id="brand-branch-dropdown"
            :text="computedBrandsBranchesTextDisplay"
            class="d-flex"
            variant="ghost"
            :toggle-class="['text-left d-flex align-items-center justify-content-between border rounded pr-4', { 'disabled-dropdown': !enabled || isLoading, 'dropdown-toggle-bold': selected_brands_branches.length > 0 && !isLoading && enabled }]"
            menu-class="w-100 p-0"
            :disabled="!enabled"
            ref="brandsBranchesDropdownToggle"
            @hide="name = null">
            <b-form-group class="p-2 mb-0">
              <b-input-group class="border rounded">
                <template #prepend>
                  <b-input-group-text class="border-0 search-brand-branch px-3"></b-input-group-text>
                </template>
                <b-form-input class="border-0" placeholder="Search Brand / Branch" autocomplete="off" v-model="name" @input="applySearch"></b-form-input>
              </b-input-group>
            </b-form-group>
            <div class="branches-container"
              v-infinite-scroll="loadMoreBrandsBranches"
              :infinite-scroll-disabled="isLoading"
              :infinite-scroll-immediate-check="true"
              infinite-scroll-distance="50">
              <div class="px-3 py-2" v-if="brands_branches.length === 0 && !isLoading">
                <small class="text-muted">No brands / branches found.</small>
              </div>
              <b-form-group class="mb-0" v-if="brands_branches.length > 0 && !isLoading && !name">
                <div class="bg-light px-3 py-2">
                  <b-form-checkbox v-model="is_all" @input="checkAllBrandBranches">
                    <span class="offset-label">All Brand / Branch</span>
                  </b-form-checkbox>
                </div>
              </b-form-group>
              <div class="px-3 py-2" v-if="isLoading">
                <small class="text-muted">Loading brands / branches...</small>
              </div>
              <template v-else>
                <b-form-group
                  class="mb-0"
                  v-for="(brand, brandIndex) in brands_branches" :key="`brand-${brandIndex}`">
                  <div class="bg-light px-3 py-2">
                    <b-form-checkbox-group v-model="selected_brands" class="d-flex justify-between">
                      <b-button
                        variant="ghost"
                        class="border-0 rounded-0 p-0 cursor-pointer collapse-trigger"
                        v-b-toggle="`branches-${brandIndex}`">
                        <span class="when-open"><img src="../../assets/images/caret-left-2.svg" alt="caret-left"></span>
                      </b-button>
                      <b-form-checkbox
                        v-if="!name"
                        :value="brand.uuid" class="mt-1 mb-0 flex-grow-1"
                        :ref="`branches-${brandIndex}`"
                        @change="handleAllBranches(brand.uuid)">
                        <span class="offset-label">{{ brand.name }}</span>
                      </b-form-checkbox>
                      <div v-else class="flex-grow-1">
                        <span class="mt-1 ml-2">{{ brand.name }}</span>
                      </div>
                      <b-button
                        variant="ghost"
                        class="border-0 rounded-0 p-0 cursor-pointer collapse-trigger"
                        v-b-toggle="`branches-${brandIndex}`">
                        <span class="when-closed"><img src="../../assets/images/caret-right-2.svg" alt="caret-right"></span>
                      </b-button>
                    </b-form-checkbox-group>
                  </div>
                  <b-collapse :id="`branches-${brandIndex}`" class="px-3 py-2 bg-light">
                    <b-form-checkbox-group v-model="selected_brands" v-if="!name">
                      <b-form-checkbox
                        :value="brand.uuid" class="mt-1 mb-0 flex-grow-1"
                        @change="handleAllBranches(brand.uuid)">
                        <span class="offset-label">All Branches</span>
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                    <b-form-checkbox-group v-model="selected_branches">
                      <template v-for="(branch, branchIndex) in brand.branches" class="py-2">
                        <b-form-checkbox
                          :value="{ branch: branch.uuid, brand: brand.uuid }"
                          class="mt-1 mb-0 d-flex py-1"
                          :key="`branch-${branchIndex}`">
                          <span class="offset-label">{{ branch.name }}</span>
                        </b-form-checkbox>
                      </template>
                    </b-form-checkbox-group>
                  </b-collapse>
                </b-form-group>
              </template>
            </div>
            <div class="dropdown-buttons-container bg-white d-flex align-items-center justify-content-between py-2 px-3">
              <b-button variant="ghost text-dark px-0" @click="handleClearSelected">Clear Selected</b-button>
              <b-button variant="primary" pill class="px-4" @click="handleApplySelected">Apply</b-button>
            </div>
          </b-dropdown>
          <b-form-invalid-feedback :force-show="isInvalid(errorKey)">
            {{ errorMessage(errorKey) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
const infiniteScroll = require('vue-infinite-scroll');

export default {
  name: "BrandBranchesComponent",
  props: ['enabled', 'origin', 'errorKey', 'selectedValue'],
  data() {
    return {
      name: null,
      page: 0,
      selected_branches: [],
      show_brands_branches: false,
      selected_brands: [],
      is_parent_trigger: false,
      is_all: false,
      selected_brands_branches: [],
      init: false
    }
  },
  computed: {
    ...mapGetters({
      branches: "branches/branches",
      brands_branches: "orderFulfillment/brands_branches",
      stored_brands_branches: 'orderFulfillment/stored_brands_branches',
      brand_branches_max_page: "orderFulfillment/brand_branches_max_page",
      errors: 'orderFulfillment/errors',
      isLoading: 'orderFulfillment/loading_branches'
    }),
    computedGroupByBrands: {
      get() {
        const brandsBranches = {};
        if (this.brands_branches.length > 0) {
          this.brands_branches.map(brand => {
            brandsBranches[`${brand.uuid}`] = brand.branches
          });
        }
        return brandsBranches;
      },
      set(branches) {
        return branches;
      }
    },
    computedBrandsBranchesTextDisplay: {
      get() {
        return this.init
          ? "Loading brands / branches..."
          : this.selected_brands_branches.length > 0
            ? this.selected_brands_branches.map(brand => {
              return `${brand.brand_name} - ${brand.branches.length} Branch${brand.branches.length > 1 ? 'es' : ''} Selected`
            }).join(', ')
            : "Select Brand / Branch";
      },
      set(text) {
        return text;
      }
    }
  },
  mounted() {
    this.$root.$on('bv::toggle::collapse', (id) => {
      if (id.includes('branches')) {
        const findBranches = document.getElementById(id);
        setTimeout(() => {
          if (this.$refs[id].length > 0 && findBranches.classList.value.includes('show')) {
            this.$nextTick(() => {
              this.$refs[id][0].$el.classList.add('collapsed-checkbox');
            });
          } else {
            this.$nextTick(() => {
              if (this.$refs[id].length > 0) this.$refs[id][0].$el.classList.remove('collapsed-checkbox');
            });
          }
        }, 400);
      }
    });
    this.$root.$on('saveFulfillmentChangesCancelled', async () => {
      this.name = null;
      this.page = 0;
    });
  },
  beforeDestroy() {
    this.$root.$off('saveFulfillmentChangesCancelled');
  },
  async created() {
    await this.initBranches();

    this._applySearch = _.debounce(() => {
      this.page = 0;
      this.loadMoreBrandsBranches(true);
    }, 400);
  },
  methods: {
    ...mapActions({
      getBrandsBranches: 'orderFulfillment/getBrandsBranches'
    }),
    // initialized stored_brands_branches to fetch all and to be used for cross-checking selected branches when filtered out by name
    async initBranches() {
      this.init = true;
      this.page = this.page + 1;
      const request = {
        init: true,
        reset: true,
        param: {
          page: this.page,
          payload: {
            name: this.name
          }
        }
      };
      await this.getBrandsBranches(request); // make 1st request to get max_page
      while (this.page < this.brand_branches_max_page && !this.isLoading) { // loop request while current_page is less than max_page
        this.page = this.page + 1;
        request.param.page = this.page;
        await this.getBrandsBranches(request);
      }
      // set page to 1 after initialization to get 2nd page when triggered via infinite scrolling, first page brands_branches already set via initialization
      if (this.page === this.brand_branches_max_page) this.page = 1;
      this.checkIsAllBranches();
      this.init = false;
    },
    checkAllBrandBranches(value) { // Check "All Brand / Branch"
      if (value) {
        Object.keys(this.computedGroupByBrands).forEach(brand => {
          this.selected_brands.push(brand);
        });
      } else this.selected_branches = [];
    },
    checkIsAllBranches() { // Check if all branches are selected to mark parent brand as checked
      if (!this.isLoading && this.selected_branches.length > 0) {
        const getBrandBraches = _.groupBy(this.selected_branches, 'brand');
        const collect_brands = this.brands_branches.map(brand => brand.uuid);
        Object.keys(getBrandBraches).forEach(brand => {
          if (
            collect_brands.includes(brand)
            && getBrandBraches[brand].length
            === this.computedGroupByBrands[brand].length
            && !this.selected_brands.includes(brand)
          ) {
            this.selected_brands.push(brand); // Push brand when all its branches are selected and not yet included in selected_brands
          } else if (
            collect_brands.includes(brand)
            && this.selected_brands.includes(brand)
            && getBrandBraches[brand].length
            !== this.computedGroupByBrands[brand].length
          ) {
            const brandIndex = this.selected_brands.indexOf(brand);
            this.$nextTick(() => {
              this.selected_brands.splice(brandIndex, 1); // Splice brand if included but not all branches are selected
              this.$nextTick(() => {
                this.is_all = false; // Set "All Brand / Branch" to false
              });
            });
          }
        });
      }
    },
    handleAllBranches(brand) { // Uncheck branches from parent brand checkbox
      this.$nextTick(() => {
        if (!this.selected_brands.includes(brand)) {
          const branches = this.brands_branches.find(item => item.uuid === brand).branches;
          branches.map(branch => {
            const branchIndex = this.selected_branches.indexOf({ branch: branch.uuid, brand: branch.brand_uuid });
            this.selected_branches.splice(branchIndex, 1);
          });
        }
      });
    },
    handleClearSelected() {
      this.selected_brands = [];
      this.selected_branches = [];
      this.is_all = false;
    },
    handleApplySelected() {
      const groupedByBrand = _.groupBy(this.selected_branches, 'brand');
      this.selected_brands_branches = Object.keys(groupedByBrand).map(uuid => {
        const brand = this.stored_brands_branches.find(brand => brand.uuid === uuid);
        return {
          brand_name: brand.name,
          brand_uuid: uuid,
          branches: groupedByBrand[uuid].map(itemBranch => {
            return {
              name: brand.branches.find(branch => branch.uuid === itemBranch.branch).name,
              uuid: itemBranch.branch
            };
          })
        };
      });
      this.$nextTick(() => {
        this.name = null;
        this.page = 0;
        this.loadMoreBrandsBranches(true);
        this.$refs.brandsBranchesDropdownToggle.hide();
        this.$emit('setBrandsBranches', { from: this.origin, data: this.selected_brands_branches });
      });
    },
    isInvalid(key) {
      return this.errors && this.errors[key]
        ? true
        : false;
    },
    errorMessage(key) {
      return this.errors && this.errors[key]
        ? this.errors[key].split('.').join(' ')
        : null;
    },
    async loadMoreBrandsBranches(reset = false) {
      this.page = this.page + 1;
      const request = {
        reset: reset,
        param: {
          page: this.page,
          payload: {
            name: this.name
          }
        }
      };
      if (!this.isLoading && !this.brand_branches_max_page) await this.getBrandsBranches(request);
      else if (this.page <= this.brand_branches_max_page && !this.isLoading) await this.getBrandsBranches(request);
      this.checkIsAllBranches();
    },
    applySearch() {
      this._applySearch();
    }
  },
  watch: {
    selected_branches: {
      deep: true,
      handler(branches) {
        this.checkIsAllBranches();
        if (branches.length === 0) this.selected_brands = [];
      }
    },
    selected_brands(brands) {
      // Check brand and push all brand's branch
      const collect_brands = this.brands_branches.map(brand => brand.uuid);
      brands.map(brand => {
        if (collect_brands.includes(brand)) {
          this.brands_branches.find(item => item.uuid == brand).branches.map(branch => {
            const checkBranches = this.selected_branches.map(item => item.branch);
            if (!checkBranches.includes(branch.uuid)) this.selected_branches.push({ branch: branch.uuid, brand: brand });
          });
        }
      });
    },
    selectedValue(brands) {
      this.selected_brands = []; // to reset checked all branches if same as delivery is checked
      this.selected_brands_branches = brands;
      this.selected_branches = brands.length > 0
        ? brands.map(brand => {
          return brand.branches.map(branch => {
            return {
              brand: brand.brand_uuid,
              branch: branch.uuid
            }
          });
        }).flat()
        : [];
    },
  },
  directives: { infiniteScroll }
}
</script>

<style lang="scss">
#brand-branch-dropdown {
  .dropdown-toggle {
    color: #68737D;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block !important;
    &::after {
      position: absolute;
      top: 15px;
      right: 12px;
    }
    &.disabled-dropdown {
      background: #E9EBED;
      cursor: not-allowed;
    }
    &.dropdown-toggle-bold {
      font-family: MainFontBold, sans-serif;
      color: #2F3941;
    }
  }
  .dropdown-menu {
    border: 0;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    overflow: hidden;
    & > .branches-container {
      max-height: 300px;
      overflow-y: auto;
    }
  }
  .search-brand-branch {
    background: url('../../assets/images/search.svg') no-repeat center;
  }
  .collapsed-checkbox > .custom-control-label::before,
  .collapsed-checkbox > .custom-control-label::after,
  .collapsed-checkbox > .custom-control-input {
    display: none !important;
  }
  .collapsed-checkbox > .custom-control-label {
    text-indent: -10px;
  }
  .dropdown-buttons-container {
    .btn.btn-primary {
      border-radius: 20px;
    }
  }
  .text-dark {
    color: #87929D !important;
  }
}
</style>

<style lang="scss" scoped>
.offset-label {
  position: relative;
  top: -3px;
}
.collapse-trigger.collapsed > .when-open {
  display: none;
}
.collapse-trigger:not(.collapsed) > .when-closed {
  display: none;
}
</style>
